export enum AdditionalTool {
    mentorscript = 'mentorscript',
    chat = 'chat',
    notes = 'notes',
}
